import { DataTable } from "./DataTable";
import { Button, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { IUserTypes, useUserModel } from "../userModel";
export const DataBox = () => {
    const { setIVisibleDrawer, tabActive, initPgCfg, searchParam, setTabActive, loadData, userExport } = useUserModel();
    const onAdd = () => {
        setIVisibleDrawer("add")
    }
    const title = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={userExport}
        >导出</Button>
    </>

    const classname = (type: any) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(IUserTypes.USER)}
            type="link"
            shape="round"
            onClick={() => loadData(initPgCfg, searchParam, IUserTypes.USER)}
        >用户管理</Button>
        <Button
            className={classname(IUserTypes.CHEF)}
            type="link"
            shape="round"
            onClick={() => loadData(initPgCfg, searchParam, IUserTypes.CHEF)}
        >厨师管理</Button>

    </>
    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <YhBox title={title}>
                <DataTable />
            </YhBox>
        </>
    )
}